<app-loader></app-loader>

@if (!hasConnection()) {
    <div class="connection-failed">
        <mat-icon color="white" class="item-margin-right">wifi_off</mat-icon>
        {{ translations.global.no_internet_connection | translate }}
    </div>
}

@if (loading()) {
    <div class="spinner spinnerContainer">
        <span class="loader"></span>
    </div>
} @else {
    @if (config.menuOrientation == configMenuOrientation.side) {
        <div class="width-100 flex flex-grow flex-col">
            @if (userLoggedIn()) {
                <app-menu-header @fade />
            }
            <div class="mainFrame flex w-full flex-grow flex-row" @fade>
                @if (appService.sideMenuOpen()) {
                    <app-menu></app-menu>
                }
                <div class="side-content flex flex-grow" sideMenuOpen isMobile @fade>
                    <router-outlet />
                </div>
            </div>
        </div>
    } @else if (config.menuOrientation == configMenuOrientation.top) {
        <div class="width-100 flex flex-grow flex-col">
            @if (userLoggedIn()) {
                <app-menu-header @fade />
            }
            <div class="default-padding flex w-full flex-grow" @fade>
                <router-outlet />
            </div>
        </div>
    }
}

@if (!loading()) {
    <app-footer />
}
